module.exports = __webpack_public_path__ + "static/media/agricultural12.bb41ff0b.jpg";